import RecommendationLongCards from './RecommendationLongCards';

export default RecommendationLongCards;
